/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.link-ireland[_ngcontent-%COMP%] {\n  font-size: 16px;\n  margin: 20px;\n  display: inline-block;\n}\n.padding-bottom-100-px[_ngcontent-%COMP%] {\n  padding-bottom: 100px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9mb3Jnb3QvZm9yZ290LmNvbXBvbmVudC5sZXNzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9mb3Jnb3QvZm9yZ290LmNvbXBvbmVudC5sZXNzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/auth/forgot/forgot.component.less.shim.ngstyle.ts